import type { KassaAppointment, KuurRefundMethod, SaleLineKind, SalonPaymentMethod } from '../../core/types/kassa'

/** Labels en kleine hulpjes voor de kassa. Pure functies, zonder React. */

export const methodLabel: Record<SalonPaymentMethod, string> = { pin: 'Pin', contant: 'Contant' }

/** Hoe het geld van een gestopte kuur teruggaat. */
export const refundMethodLabel: Record<KuurRefundMethod, string> = { pin: 'Pin', contant: 'Contant', tegoed: 'Als tegoed' }

export const kindLabel: Record<SaleLineKind, string> = { treatment: 'Behandeling', product: 'Product', kuur: 'Kuur vooruit', giftcard: 'Cadeaubon · geen btw' }

/** Vaste bedragen om een cadeaubon met één tik op de bon te zetten (in centen); een ander bedrag kan daarna. */
export const giftCardAmounts = [2500, 5000, 7500, 10000, 15000]

/** "2026-10-05T14:05" → "14:05". */
export const clock = (stamp: string) => stamp.slice(11, 16)

/** Mag de behandeling van deze afspraak uit een vooruitbetaalde kuur? (De server controleert het opnieuw.) */
export const paidFromKuur = (a: Pick<KassaAppointment, 'session' | 'kuur' | 'treatmentSlug'>) =>
  Boolean(a.session && a.kuur?.prepaid && !a.kuur.expired && a.kuur.treatmentSlug === a.treatmentSlug)

/** Waar de afspraak staat, voor het label in "Af te rekenen". */
export const settleState = (a: Pick<KassaAppointment, 'finished' | 'started'>): { label: string; tone: 'success' | 'soft' | 'neutral' } =>
  a.finished ? { label: 'Nog afrekenen', tone: 'success' } : a.started ? { label: 'Bezig', tone: 'soft' } : { label: 'Straks', tone: 'neutral' }
